/* eslint-disable import/prefer-default-export */
const APP_ENTRYPOINT = process.env.REACT_APP_APP_ENTRYPOINT;

export { APP_ENTRYPOINT };
